// Central extension registry for the TipTap document editor.
// Combines built-in TipTap extensions with our custom block nodes.

import StarterKit from '@tiptap/starter-kit';
import Underline from '@tiptap/extension-underline';
import Link from '@tiptap/extension-link';
import Placeholder from '@tiptap/extension-placeholder';
import { TextStyle } from '@tiptap/extension-text-style';
import Color from '@tiptap/extension-color';
import Highlight from '@tiptap/extension-highlight';
import TaskList from '@tiptap/extension-task-list';
import TaskItem from '@tiptap/extension-task-item';
import { Table } from '@tiptap/extension-table';
import TableRow from '@tiptap/extension-table-row';
import TableCell from '@tiptap/extension-table-cell';
import TableHeader from '@tiptap/extension-table-header';
import Image from '@tiptap/extension-image';
import TextAlign from '@tiptap/extension-text-align';
import type { Extensions } from '@tiptap/react';

import { CalloutNode, ToggleNode, ChartNode, DiagramNode, EquationNode } from './nodes';
import { SlashCommand } from './SlashCommand';

export function createExtensions(placeholder?: string): Extensions {
  return [
    StarterKit.configure({
      heading: { levels: [1, 2, 3] },
      codeBlock: false, // We use CodeBlockLowlight separately or default for now
      // horizontalRule, blockquote, bulletList, orderedList, listItem are enabled by default
    }),
    Underline,
    Link.configure({
      openOnClick: false,
      HTMLAttributes: { class: 'text-primary underline cursor-pointer' },
    }),
    Placeholder.configure({
      placeholder: placeholder ?? "Type '/' for commands...",
    }),
    TextStyle,
    Color,
    Highlight.configure({ multicolor: true }),
    TaskList,
    TaskItem.configure({ nested: true }),
    Table.configure({ resizable: true }),
    TableRow,
    TableCell,
    TableHeader,
    Image,
    TextAlign.configure({ types: ['heading', 'paragraph'] }),
    // Custom nodes
    CalloutNode,
    ToggleNode,
    ChartNode,
    DiagramNode,
    EquationNode,
    // Slash command menu
    SlashCommand,
  ];
}
